import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import HudModal from "./HudModal";
import { formatErr, inputCls, labelCls } from "../lib/constants";

export default function ChangePasswordDialog({ open, onClose }) {
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Şifreniz değiştirildi");
      setCur(""); setNext("");
      onClose();
    } catch (err) {
      toast.error(formatErr(err));
    }
    setSaving(false);
  };

  return (
    <HudModal open={open} onClose={onClose} title="Şifremi Değiştir" testid="password-dialog">
      <form onSubmit={save} className="space-y-3">
        <div><label className={labelCls}>Mevcut Şifre</label><input data-testid="cp-current" type="password" required value={cur} onChange={(e) => setCur(e.target.value)} className={inputCls} /></div>
        <div><label className={labelCls}>Yeni Şifre (en az 6 karakter)</label><input data-testid="cp-new" type="password" required minLength={6} value={next} onChange={(e) => setNext(e.target.value)} className={inputCls} /></div>
        <button data-testid="cp-save" disabled={saving} className="w-full btn-cyan py-2.5 rounded-lg font-mono text-xs uppercase tracking-widest disabled:opacity-50">
          {saving ? "Kaydediliyor..." : "Şifreyi Güncelle"}
        </button>
      </form>
    </HudModal>
  );
}
